import { render, staticRenderFns } from "./RequestReviewDialog.vue?vue&type=template&id=a8ff2d8c&"
import script from "./RequestReviewDialog.vue?vue&type=script&lang=js&"
export * from "./RequestReviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports